import { render } from "./2016-11-20-Cluster Paper Reading.md?vue&type=template&id=d511bf14"
const script = {}
script.render = render

export default script